import './ServiceItem.css';

import React from 'react'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Card, Col, Row } from 'react-bootstrap';
import { memo } from 'react';
import { iconsMap } from '../../utils';
import UserItem from '../common/UserItem';
import { useAuth } from '../../contexts/auth';
import { BdaService } from '../../models/BdaService';
import { Tooltip } from 'antd';
// import { formatDate } from '../utils';

type Props = {
  service: BdaService;
  actions?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  onClone?: React.MouseEventHandler<HTMLButtonElement>;
  onEdit?: React.MouseEventHandler<HTMLButtonElement>;
  onDelete?: React.MouseEventHandler<HTMLButtonElement>;
}

function ServiceItem({ service, actions, onClick, onClone, onEdit, onDelete }: Props) {
  const { loggedUser } = useAuth();

  return (
    <Card className="service-item" onClick={onClick}>
      <Card.Header className="service-item-header bg-service">
        <Row className="gx-0 align-items-start justify-content-between">
          <Badge bg="none" className="service-version">{service.version}</Badge>
          <Badge className="shadow w-auto">{service.accessLevel}</Badge>
        </Row>
        <FontAwesomeIcon className="service-icon" icon={iconsMap.get(service.area!) || solid('chart-pie')} />

        <div className="header-content">
          <Tooltip title={service.name} mouseEnterDelay={0.3}>
            <h5 className="service-title text-white mb-2">{service.name}</h5>
          </Tooltip>
          <p className="service-description line-clamp-2 mt-2">{service.description}</p>
        </div>

        <Row className="gx-0 position-relative justify-content-center">
          {actions || (loggedUser?.sub === service.owner!.id && (
            <Col className="text-center" xs={9}>
              <Tooltip title="Clone">
                <button className="circle-button" onClick={onClone}>
                  <FontAwesomeIcon size="sm" icon={solid('clone')} />
                </button>
              </Tooltip>
              <Tooltip title="Edit">
                <button className="circle-button ms-2" onClick={onEdit}>
                  <FontAwesomeIcon size="sm" icon={solid('pen')} />
                </button>
              </Tooltip>
              <Tooltip title="Delete">
                <button className="circle-button ms-2" onClick={onDelete}>
                  <FontAwesomeIcon size="sm" icon={solid('trash')} />
                </button>
              </Tooltip>
            </Col>
          ))}
        </Row>
      </Card.Header>
      <Card.Body className="p-2">
        <div className="d-flex align-items-center">
          <Col className="overflow-hidden">
            <UserItem user={service.owner!} organization={service.organization!} />
          </Col>

          <div className="framework-image" style={{ backgroundImage: `url(${service.framework!.imageUrl})` }} />
        </div>
      </Card.Body>
    </Card>
  )
}

export default memo(ServiceItem);